import React, { ReactElement } from 'react';

export const Consigned = (): ReactElement => {
  return (
    <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect opacity="0.6" width="52" height="52" rx="8" fill="#E6F5FE" />
      <rect x="18" y="18" width="21" height="21" rx="3" stroke="#0090FF" strokeWidth="2" />
      <rect opacity="0.5" x="26" y="22" width="5" height="6" rx="2.5" stroke="#0090FF" strokeWidth="2" />
      <g opacity="0.5">
        <mask id="mask0_2217_5808" maskUnits="userSpaceOnUse" x="21" y="21" width="15" height="15">
          <rect x="21" y="21" width="15" height="15" rx="1" fill="#C4C4C4" />
        </mask>
        <g mask="url(#mask0_2217_5808)">
          <rect x="22" y="32" width="13" height="22" rx="4" stroke="#0090FF" strokeWidth="2" />
        </g>
      </g>
      <path
        opacity="0.5"
        d="M16 14H31C31.7403 14 32.3866 14.4022 32.7324 15H34.874C34.4299 13.2748 32.8638 12 31 12H16C13.7909 12 12 13.7909 12 16V31C12 32.8638 13.2748 34.4299 15 34.874V32.7324C14.4022 32.3866 14 31.7403 14 31V16C14 14.8954 14.8954 14 16 14Z"
        fill="#0090FF"
      />
    </svg>
  );
};

export const Fgts = (): ReactElement => {
  return (
    <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect opacity="0.6" width="52" height="52" rx="8" fill="#E6F5FE" />
      <path
        d="M15 14C15 12.8954 15.8954 12 17 12H29.7574C30.2878 12 30.7965 12.2107 31.1716 12.5858L36.4142 17.8284C36.7893 18.2035 37 18.7122 37 19.2426V38C37 39.1046 36.1046 40 35 40H17C15.8954 40 15 39.1046 15 38V14Z"
        stroke="#0090FF"
        strokeWidth="2"
      />
      <rect opacity="0.5" x="20" y="29" width="9" height="2" rx="1" fill="#0090FF" />
      <rect opacity="0.5" x="20" y="33" width="12" height="2" rx="1" fill="#0090FF" />
      <g opacity="0.5">
        <path
          d="M21.5 24C20.9477 24 20.5 24.4477 20.5 25C20.5 25.5523 20.9477 26 21.5 26L21.5 24ZM24.2348 20C24.787 20 25.2348 19.5523 25.2348 19C25.2348 18.4477 24.787 18 24.2348 18L24.2348 20ZM23.5076 25L23.5076 26L23.5076 25ZM24.2348 18L22.5076 18L22.5076 20L24.2348 20L24.2348 18ZM22.5076 23.0152L23.5076 23.0152L23.5076 21.0152L22.5076 21.0152L22.5076 23.0152ZM23.5076 24L21.5 24L21.5 26L23.5076 26L23.5076 24ZM24 23.5076C24 23.7795 23.7795 24 23.5076 24L23.5076 26C24.8841 26 26 24.8841 26 23.5076L24 23.5076ZM23.5076 23.0152C23.7796 23.0152 24 23.2357 24 23.5076L26 23.5076C26 22.1311 24.8841 21.0152 23.5076 21.0152L23.5076 23.0152ZM20 20.5076C20 21.8925 21.1227 23.0152 22.5076 23.0152L22.5076 21.0152C22.2273 21.0152 22 20.7879 22 20.5076L20 20.5076ZM22.5076 18C21.1227 18 20 19.1227 20 20.5076L22 20.5076C22 20.2273 22.2273 20 22.5076 20L22.5076 18Z"
          fill="#0090FF"
        />
        <path d="M22 18C22 17.4477 22.4477 17 23 17C23.5523 17 24 17.4477 24 18V19H22V18Z" fill="#0090FF" />
        <path d="M22 25H24V26C24 26.5523 23.5523 27 23 27C22.4477 27 22 26.5523 22 26V25Z" fill="#0090FF" />
      </g>
    </svg>
  );
};

export const Pencil = () => {
  return (
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20.0003 5.24081C20.001 5.1092 19.9758 4.97874 19.926 4.8569C19.8763 4.73507 19.8029 4.62425 19.7103 4.53081L15.4703 0.29081C15.3768 0.198129 15.266 0.124804 15.1442 0.0750389C15.0223 0.0252743 14.8919 4.92783e-05 14.7603 0.000810171C14.6287 4.92783e-05 14.4982 0.0252743 14.3764 0.0750389C14.2545 0.124804 14.1437 0.198129 14.0503 0.29081L11.2203 3.12081L0.290261 14.0508C0.197579 14.1442 0.124254 14.2551 0.0744896 14.3769C0.024725 14.4987 -0.000500038 14.6292 0.000260855 14.7608V19.0008C0.000260855 19.266 0.105618 19.5204 0.293154 19.7079C0.48069 19.8955 0.735044 20.0008 1.00026 20.0008H5.24026C5.38019 20.0084 5.52015 19.9865 5.65108 19.9366C5.78201 19.8866 5.90097 19.8097 6.00026 19.7108L16.8703 8.78081L19.7103 6.00081C19.8015 5.90389 19.8759 5.79234 19.9303 5.67081C19.9399 5.5911 19.9399 5.51052 19.9303 5.43081C19.9349 5.38426 19.9349 5.33736 19.9303 5.29081L20.0003 5.24081ZM4.83026 18.0008H2.00026V15.1708L11.9303 5.24081L14.7603 8.07081L4.83026 18.0008ZM16.1703 6.66081L13.3403 3.83081L14.7603 2.42081L17.5803 5.24081L16.1703 6.66081Z"
        fill="#0090FF"
      />
    </svg>
  );
};

export const ChekcConfirmation = () => {
  return (
    <svg width="289" height="140" viewBox="0 0 289 140" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.5"
        d="M4.07279 61.2593C6.32212 61.2593 8.14557 59.4359 8.14557 57.1866C8.14557 54.9372 6.32212 53.1138 4.07279 53.1138C1.82345 53.1138 0 54.9372 0 57.1866C0 59.4359 1.82345 61.2593 4.07279 61.2593Z"
        fill="#0090FF"
      />
      <path
        d="M75.1202 35.9177C76.6198 35.9177 77.8354 34.7021 77.8354 33.2025C77.8354 31.7029 76.6198 30.4873 75.1202 30.4873C73.6207 30.4873 72.405 31.7029 72.405 33.2025C72.405 34.7021 73.6207 35.9177 75.1202 35.9177Z"
        fill="#0090FF"
      />
      <path
        d="M48.6111 6.33544C50.3606 6.33544 51.7788 4.91721 51.7788 3.16772C51.7788 1.41824 50.3606 0 48.6111 0C46.8616 0 45.4434 1.41824 45.4434 3.16772C45.4434 4.91721 46.8616 6.33544 48.6111 6.33544Z"
        fill="#0090FF"
      />
      <path
        d="M57.0189 73.0255C58.0186 73.0255 58.829 72.2151 58.829 71.2154C58.829 70.2157 58.0186 69.4053 57.0189 69.4053C56.0192 69.4053 55.2087 70.2157 55.2087 71.2154C55.2087 72.2151 56.0192 73.0255 57.0189 73.0255Z"
        fill="#0090FF"
      />
      <path
        opacity="0.1"
        d="M131.234 6.05043C132.234 6.05043 133.044 5.24001 133.044 4.2403C133.044 3.2406 132.234 2.43018 131.234 2.43018C130.234 2.43018 129.424 3.2406 129.424 4.2403C129.424 5.24001 130.234 6.05043 131.234 6.05043Z"
        fill="#0090FF"
      />
      <path
        opacity="0.2"
        d="M28.9621 116.469C31.4613 116.469 33.4874 114.443 33.4874 111.943C33.4874 109.444 31.4613 107.418 28.9621 107.418C26.4628 107.418 24.4368 109.444 24.4368 111.943C24.4368 114.443 26.4628 116.469 28.9621 116.469Z"
        fill="#0090FF"
      />
      <path
        d="M105.849 128.234C108.348 128.234 110.374 126.208 110.374 123.709C110.374 121.21 108.348 119.184 105.849 119.184C103.349 119.184 101.323 121.21 101.323 123.709C101.323 126.208 103.349 128.234 105.849 128.234Z"
        fill="#0090FF"
      />
      <path
        d="M177.845 140C179.594 140 181.013 138.582 181.013 136.832C181.013 135.083 179.594 133.665 177.845 133.665C176.095 133.665 174.677 135.083 174.677 136.832C174.677 138.582 176.095 140 177.845 140Z"
        fill="#0090FF"
      />
      <path
        d="M284.19 111.038C286.689 111.038 288.715 109.012 288.715 106.513C288.715 104.013 286.689 101.987 284.19 101.987C281.691 101.987 279.665 104.013 279.665 106.513C279.665 109.012 281.691 111.038 284.19 111.038Z"
        fill="#0090FF"
      />
      <path
        d="M247.987 69.4049C248.987 69.4049 249.798 68.5945 249.798 67.5948C249.798 66.5951 248.987 65.7847 247.987 65.7847C246.988 65.7847 246.177 66.5951 246.177 67.5948C246.177 68.5945 246.988 69.4049 247.987 69.4049Z"
        fill="#0090FF"
      />
      <path
        opacity="0.5"
        d="M214.544 57.6389C216.543 57.6389 218.164 56.0181 218.164 54.0187C218.164 52.0193 216.543 50.3984 214.544 50.3984C212.545 50.3984 210.924 52.0193 210.924 54.0187C210.924 56.0181 212.545 57.6389 214.544 57.6389Z"
        fill="#0090FF"
      />
      <path
        opacity="0.8"
        d="M280.57 14.1961C283.069 14.1961 285.095 12.1701 285.095 9.67082C285.095 7.17156 283.069 5.14551 280.57 5.14551C278.07 5.14551 276.044 7.17156 276.044 9.67082C276.044 12.1701 278.07 14.1961 280.57 14.1961Z"
        fill="#0090FF"
      />
      <path
        d="M214.047 12.3863C216.297 12.3863 218.12 10.5628 218.12 8.31351C218.12 6.06417 216.297 4.24072 214.047 4.24072C211.798 4.24072 209.975 6.06417 209.975 8.31351C209.975 10.5628 211.798 12.3863 214.047 12.3863Z"
        fill="#0090FF"
      />
      <rect x="99.8577" y="16" width="90" height="90" rx="36" fill="#0090FF" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M162.991 51.3852C164.163 52.5568 164.163 54.4563 162.991 55.6279L142.485 76.134C141.314 77.3055 139.414 77.3055 138.242 76.134L125.736 63.6279C124.565 62.4563 124.565 60.5568 125.736 59.3852C126.908 58.2137 128.807 58.2137 129.979 59.3852L140.364 69.77L158.749 51.3852C159.92 50.2137 161.82 50.2137 162.991 51.3852Z"
        fill="white"
      />
    </svg>
  );
};

export const Clip = () => {
  return (
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.50008 15.5501L6.73008 17.2701C6.26595 17.7342 5.63646 17.995 4.98008 17.995C4.3237 17.995 3.69421 17.7342 3.23008 17.2701C2.76595 16.806 2.50521 16.1765 2.50521 15.5201C2.50521 14.8637 2.76595 14.2342 3.23008 13.7701L7.77008 9.22009C8.21569 8.77304 8.8161 8.51437 9.44709 8.49762C10.0781 8.48087 10.6914 8.70731 11.1601 9.13009L11.2801 9.23009C11.4697 9.41575 11.7253 9.51846 11.9907 9.51565C12.2561 9.51284 12.5094 9.40472 12.6951 9.21509C12.8807 9.02547 12.9835 8.76985 12.9806 8.50449C12.9778 8.23912 12.8697 7.98575 12.6801 7.80009C12.6236 7.72712 12.5636 7.65703 12.5001 7.59009C11.6464 6.84741 10.5424 6.45694 9.41165 6.49779C8.28088 6.53864 7.20791 7.00775 6.41008 7.81009L1.81008 12.3601C1.02844 13.2109 0.605701 14.3308 0.630155 15.4858C0.654609 16.6409 1.12436 17.7419 1.94131 18.5589C2.75826 19.3758 3.85924 19.8456 5.01433 19.87C6.16941 19.8945 7.28929 19.4717 8.14008 18.6901L9.87008 17.0001C10.0409 16.8137 10.1348 16.5696 10.1329 16.3168C10.131 16.064 10.0334 15.8214 9.85979 15.6376C9.68618 15.4539 9.44942 15.3427 9.19715 15.3264C8.94488 15.3102 8.69582 15.3901 8.50008 15.5501ZM19.1901 1.31009C18.3489 0.474102 17.2111 0.00488281 16.0251 0.00488281C14.8391 0.00488281 13.7013 0.474102 12.8601 1.31009L11.1301 3.00009C10.9593 3.18644 10.8654 3.43057 10.8673 3.68336C10.8692 3.93615 10.9668 4.17883 11.1404 4.36258C11.314 4.54633 11.5507 4.65751 11.803 4.67375C12.0553 4.68998 12.3043 4.61007 12.5001 4.45009L14.2301 2.73009C14.6942 2.26597 15.3237 2.00522 15.9801 2.00522C16.6365 2.00522 17.266 2.26597 17.7301 2.73009C18.1942 3.19422 18.455 3.82372 18.455 4.48009C18.455 5.13647 18.1942 5.76596 17.7301 6.23009L13.1901 10.7801C12.7445 11.2272 12.1441 11.4858 11.5131 11.5026C10.8821 11.5193 10.2688 11.2929 9.80008 10.8701L9.68008 10.7701C9.49045 10.5844 9.23484 10.4817 8.96947 10.4845C8.70411 10.4874 8.45073 10.5955 8.26508 10.7851C8.07943 10.9747 7.97671 11.2303 7.97952 11.4957C7.98234 11.7611 8.09045 12.0144 8.28008 12.2001C8.35272 12.2744 8.42951 12.3445 8.51008 12.4101C9.36476 13.1505 10.4683 13.5395 11.5984 13.4987C12.7285 13.4579 13.8011 12.9903 14.6001 12.1901L19.1501 7.64009C19.9914 6.80417 20.4678 5.66932 20.4753 4.48334C20.4828 3.29736 20.0208 2.15659 19.1901 1.31009Z"
        fill="white"
      />
    </svg>
  );
};
